<template>
  <div>
    <v-tooltip v-if="canEdit" bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon small @click="$emit('click')" v-on="on">
          <v-icon v-text="icon" />
        </v-btn>
      </template>
      <span>案件の編集</span>
    </v-tooltip>
    <v-btn v-if="!canEdit" @click="$emit('click')">
      詳細
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'EditButton',
  props: {
    canEdit: {
      type: Boolean,
      default: false,
    },
    permission: {
      type: String,
      default: 'readonly',
    },
  },
  computed: {
    icon() {
      return this.permission === 'readonly' || this.permission === 'none'
        ? 'visibility'
        : 'edit'
    },
  },
}
</script>
